<form [formGroup]="form" (ngSubmit)="onSubmit()" class="h-full w-full overflow-x-hidden overflow-y-auto flex flex-col items-center justify-start space-y-4">
    <div class="mt-6 mb-3">
        <h1 class="text-primary">Algo más de información...</h1>
    </div>

    <app-selected class="w-full"
        [config]="dataSelected().at(0)"
        (selectValue)="handleValue($event)"
    ></app-selected>
    
    @switch (asotipId()) {
        @case (1) {
            <app-independent class="w-full" 
            [defaultData]="defaultData()"
                (formSubmit)="handleEvent($event, 1)"></app-independent>
        }
        @case (2) {
            <app-associated class="w-full"
            [defaultData]="defaultData()"
            (formValid)="handleEvent($event, 2)"></app-associated>
        }
        @case (3) {
            <app-pensioners class="w-full"
            [defaultData]="defaultData()"
            (formValid)="handleEvent($event, 3)"></app-pensioners>
        }
        @case (5) {
            <app-agricultural class="w-full"
            [defaultData]="defaultData()"
            (formValid)="handleEvent($event, 5)"></app-agricultural>
        }
    }

    <app-locations class="w-full m-0" 
        (valueState)="setLocation($event)" 
        [resetTimer]="resetTimer()">
    </app-locations>

    @for (config of dataInputs(); track $index) {
        <app-input
            class="w-full"
            [config]="config"
            (submitValue)="handleValue($event)"
        ></app-input>
    }

    <app-selected class="w-full"
        [config]="dataSelected().at(1)"
        (selectValue)="handleValue($event)"
    ></app-selected>

    @if (asotipId() === 1) {
        <app-automatic-debit class="w-full"
            [defaultValue]="defaultData()"
            (formValueChange)="handleEvent($event, 40)"
        ></app-automatic-debit>
    }


    <button class="btn-primary mb-6" [disabled]="!isValidData()">
        Continuar
    </button>
</form>

@if (showQuotaModal()) {
    <app-modal>
        <div class="flex flex-col items-center justify-center text-center">
            <h1 class="text-primary mb-4">Información</h1>

            <img src="svg/part.svg" alt="info" class="w-32 h-auto mb-4"/>
            <p class="text-sm font-semibold mb-6">{{  `El valor de aporte es de $${defaultData().calculatedQuota}. Disfruta todo lo que Fincomercio tiene para ti: créditos, ahorros, seguros y convenios en recreación, deporte, salud y tecnología. Con tu Fondo Mutual CREER accede a citas con especialistas a precios preferenciales. Conoce más en www.fincomecio.com` }}</p>
            <button class="btn-primary" (click)="showQuotaModal.set(false)">Aceptar</button>
        </div>
    </app-modal>
}

@if (isValidAddress()) {
<div class="fixed inset-0 z-50 flex items-center justify-center p-4 md:hidden">
    <div class="absolute inset-0 bg-black/30 backdrop-blur-sm"></div>
    
    <div class="relative bg-white rounded-2xl shadow-xl w-full max-w-md animate-scale-in overflow-hidden">
      <div class="p-6 text-center">
        <h2 class="text-2xl font-bold text-blue-800 mb-4">Revisa tu dirección</h2>
        
        <div class="my-5 flex justify-center">
          <div class="w-52 h-52 bg-blue-100 rounded-full flex items-center justify-center">
            <img src="svg/not-found-address.svg" alt="Validación de dirección">
          </div>
        </div>
        <div class="flex flex-col space-y-3">
          
        <button class="btn-primary !bg-[#003085] min-h-12 mb-3" (click)="backValidateAddress()">
            CORREGIR DIRECCIÓN
        </button>
        <hr>
        <div class="flex justify-center items-center text-center pt-2">
          <label for="address" class="text-sm font-semibold"> Has ingresado la dirección: <b>{{ form.get('address')?.value }}</b> </label>
        </div>
        <div class="flex items-start">
          <div class="flex items-center h-5">
            <input id="address-validation" type="checkbox" 
                  class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                  (change)="onCheckboxChange($event)">
          </div>
          <label for="address-validation" class="ms-2 text-sm text-gray-700 text-left">
            La dirección es Correcta
          </label>
        </div>
        
          <button id="" class="btn-secundary" 
                  (click)="validateAddress()" [disabled]="!isChecked">
            Confirmar
          </button>
        </div>
      </div>
    </div>
  </div>
}

